import {
  Box,
  keyframes,
  StyledSystem,
} from '@project44/manifest-ui-deprecated';

interface SkeletonProps {
  sx?: StyledSystem.SystemStyleObject;
  variant?: 'dark' | 'light';
}

const shine = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 500px 0;
  }
`;

const gradient = (primary: string, secondary: string) => `
  linear-gradient(90deg,
    ${secondary} 0%,
    ${primary} 33%,
    ${primary} 66%,
    ${secondary} 100%
  );
`;

const gradientLight = gradient('#F4F4F4', 'rgba(213, 215, 217, 0.8)');
const gradientDark = gradient('#10277c', 'rgb(56, 85, 179, 0.8)');

function Skeleton({ sx, variant = 'light' }: SkeletonProps) {
  return (
    <Box
      data-testid="skeleton"
      sx={{
        background: variant === 'dark' ? gradientDark : gradientLight,
        backgroundSize: '500px 100%',
        animation: `${shine} 1.8s linear infinite`,
        borderRadius: '9999px',
        height: '12px',
        ...sx,
      }}
    />
  );
}

export default Skeleton;
